import { createReducer } from '@reduxjs/toolkit';
import { loadTasks, loadTasksSuccess, loadTasksError, loadSummarySuccess } from './actions';
import type { TaskOrder, TaskSummary } from '@/lib/types';

export interface TasksState {
  tasks: TaskOrder[];
  summary: TaskSummary | null;
  loading: boolean;
  error: string | null;
}

export const initialState: TasksState = {
  tasks: [],
  summary: null,
  loading: false,
  error: null,
};

const reducer = createReducer(initialState, builder => {
  builder
    .addCase(loadTasks, state => {
      state.loading = true;
      state.error = null;
    })
    .addCase(loadTasksSuccess, (state, action) => {
      state.loading = false;
      state.tasks = action.payload.tasks as TaskOrder[];
    })
    .addCase(loadTasksError, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    })
    .addCase(loadSummarySuccess, (state, action) => {
      state.summary = action.payload.summary as TaskSummary;
    });
});

export default reducer;
